import React from 'react'

import colors from '../lib/colors'

const Hand = ({ baseColor, altColor, primaryColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100"
      height="245"
      viewBox="0 0 100 245"
    >
      <defs>
        <path
          id="joels-hand-rotated-a"
          d="M95.2237818,166.629768 C91.3295474,160.874741 71.1937427,156.490236 46.9390373,156.490236 C24.785555,156.490236 6.0682322,160.147974 0.0241821419,165.166884 C19.4068288,118.706302 39.6337784,77.9832841 60.705031,42.9978316 L61.7322585,41.0715674 C68.5887338,19.5566306 73.7955664,8.79916213 77.3527561,8.79916213 C80.6155416,8.79916213 81.1166182,13.5787902 78.8559859,23.1380463 L78.8559977,23.1380244 L82.8202951,15.9522397 C95.6052756,4.48333701 104.266326,-0.801368453 108.803447,0.0981233449 L109.476234,0.60130278 C110.175306,1.50603429 109.951044,2.45915032 108.803447,3.46065087 C107.082052,4.96290169 97.4626633,12.8248248 97.4626633,14.8900501 L97.4626633,15.1535478 C97.9544359,15.3982022 98.7255394,15.3103696 99.7759737,14.8900501 C101.351625,14.2595708 103.142916,13.7523199 104.835774,14.1441374 C105.964347,14.4053491 106.574425,15.5071436 106.666009,17.4495209 C106.593319,18.428371 107.305798,18.8160863 108.803447,18.612667 C111.049921,18.307538 112.363411,18.6861441 113.198347,20.5174612 C113.754971,21.7383393 113.754971,22.8116599 113.198347,23.7374231 C112.774092,24.6199928 113.125949,24.9432196 114.253918,24.7071036 C115.945871,24.3529295 116.733565,24.7071036 117.585842,26.8252316 C118.154026,28.2373169 117.043385,30.0244662 114.253918,32.1866794 C113.550204,32.5612038 112.975397,33.4458553 112.529496,34.8406339 C111.860646,36.9328018 112.632853,43.9070669 104.268662,50.7189783 L95.2237818,166.629768 Z"
        />
        <path
          id="joels-hand-rotated-c"
          d="M21.1735762,8.99951733 C21.1755023,9.05909716 21.1764706,9.11884672 21.1764706,9.17875841 C21.1764706,13.3706699 16.4359562,16.7688856 10.5882353,16.7688856 C4.74051441,16.7688856 0,13.3706699 0,9.17875841 C0,9.11884672 0.000968332285,9.05909716 0.00289438966,8.99951733 L0,9.00224383 L-1.30124098e-05,0.502420241 C-1.30124098e-05,0.307489025 0.158009961,0.149466052 0.352941176,0.149466052 C0.394139634,0.149466052 0.435019987,0.156678949 0.473730806,0.170778077 C3.31381178,1.20518312 4.95389129,2.00141092 5.39396935,2.55946148 C5.39470834,2.56039857 5.3954457,2.56133573 5.39618145,2.56227296 C6.93028659,1.94233148 8.70163965,1.58863126 10.5882353,1.58863126 C12.4748309,1.58863126 14.246184,1.94233148 15.7802891,2.56227296 C15.7810249,2.56133573 15.7817623,2.56039857 15.7825012,2.55946148 C16.2225793,2.00141092 17.8626588,1.20518312 20.7027398,0.170778077 C20.7414506,0.156678949 20.782331,0.149466052 20.8235294,0.149466052 C21.0184606,0.149466052 21.1764836,0.307489025 21.1764836,0.502420241 L21.1764706,9.00224383 L21.1735762,8.99951733 Z"
        />
        <path
          id="joels-hand-rotated-d"
          d="M6.9545211,7.74790924 C2.77353955,8.27970826 -1.0658141e-13,9.21380816 -1.0658141e-13,10.2773134 C-1.0658141e-13,11.932203 6.71572875,13.2737561 15,13.2737561 C23.2842712,13.2737561 30,11.932203 30,10.2773134 C30,9.23458441 27.3337677,8.31625411 23.2888917,7.7795349"
        />
        <path
          id="joels-hand-rotated-e"
          d="M6.70588235,12.8930978 C16.4499268,13.1961564 23.2779664,11.1412534 27.1900013,6.72838878 C31.1020361,2.31552416 28.2602593,0.0727278982 18.6646707,-4.26325641e-14 L7.41735675,3.71279203 L3.27265755,6.35117338 L0.102983149,13.8678455 L6.70588235,12.8930978 Z"
        />
        <path
          id="joels-hand-rotated-g"
          d="M1.55336854e-12,6.17801047 C1.93809765,2.56051084 6.73828791,0 12.3529412,0 C17.9675944,0 22.7677847,2.56051084 24.7058824,6.17801047 C22.7677847,9.79551011 17.9675944,12.3560209 12.3529412,12.3560209 C6.73828791,12.3560209 1.93809765,9.79551011 -1.75415238e-14,6.17801047 Z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="rotate(150 60.29 116.572)">
        <ellipse
          cx="49.059"
          cy="168.748"
          className="fa sb"
          // fill={altColor}
          // stroke={baseColor}
          strokeWidth="1.765"
          rx="48.176"
          ry="11.297"
        />
        <ellipse
          cx="49.059"
          cy="169.631"
          className="fb sb"
          // fill={baseColor}
          // stroke={baseColor}
          strokeWidth="1.765"
          rx="24"
          ry="4.413"
        />
        <path
          className="fa sb"
          // fill={altColor}
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M43.2080336,232.434691 C41.4590591,234.255707 38.9589541,235.334834 36.2403175,235.192289 C31.2735199,234.931866 27.4581487,230.692455 27.7184475,225.723298 C27.8704974,222.820636 29.3795914,220.311045 31.5984121,218.777647 C35.2795108,215.029536 37.5967383,210.303785 38.5500946,204.600394 L40.6302229,169.261263 C40.7016775,167.897181 44.0840312,166.964329 48.4664998,167.194114 C52.8489683,167.423898 56.3437356,168.715983 56.272281,170.080065 L54.0301291,212.883192 C54.4320238,215.689267 55.5688471,218.029735 57.440599,219.904598 C59.6627604,221.654376 61.0290391,224.421371 60.8697878,227.461511 C60.6094889,232.430668 56.37209,236.247851 51.4052923,235.987429 C48.5530177,235.837876 46.0804653,234.376117 44.5414416,232.217506 C44.2221715,231.92988 43.7777021,232.002275 43.2080336,232.434691 Z"
        />
        <ellipse
          cx="49.059"
          cy="204.404"
          className="fb"
          // fill={baseColor}
          rx="1"
          ry="1"
        />
        <path
          className="fa sb"
          // fill={altColor}
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M32.4733842,224.703067 C31.8270737,226.69872 32.0614358,228.169675 33.1764706,229.115931"
        />
        <ellipse
          cx="35.647"
          cy="230.528"
          className="fb"
          // fill={baseColor}
          rx="1"
          ry="1"
        />
        <path
          className="sb"
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M50.4705882,167.159312 L49.0588235,201.579656"
        />
        <path
          className="sb"
          // stroke={baseColor}
          strokeLinecap="round"
          strokeWidth="1.765"
          d="M0.705882353,168.747943 C20.5502485,120.813818 41.2825878,78.9100471 62.9029004,43.0366303 L63.9311731,41.1096771 C70.7946249,19.5870452 76.0067554,8.82572924 79.5675645,8.82572924 C83.1283737,8.82572924 83.4032659,14.5088437 80.3922413,25.8750726 C87.2129933,29.3364371 90.4020977,34.7949089 89.9595546,42.2504881"
        />
        <path
          className="sb"
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M85.0588235,15.9601603 C97.8553062,4.48556306 106.524149,-0.801766347 111.065352,0.0981720649 L111.738744,0.601601338 C112.438445,1.50678206 112.213981,2.46037133 111.065352,3.46236914 C109.342408,4.96536586 99.7143649,12.8311926 99.7143649,14.8974433 L99.7143649,15.1610718 C100.20658,15.4058477 100.978377,15.3179715 102.029757,14.8974433 C103.606826,14.266651 105.399728,13.7591481 107.094109,14.1511602 C108.223697,14.4125016 108.834324,15.5148432 108.925991,17.4581849 C108.853235,18.437521 109.566355,18.8254289 111.065352,18.6219085 C113.313846,18.316628 114.628518,18.6954221 115.464206,20.5276485 C116.02133,21.7491328 116.02133,22.8229863 115.464206,23.7492091 C114.693885,25.0404945 114.873216,25.5680205 116.0022,25.3317872 C117.695676,24.9774373 119.002604,24.7193711 119.855647,26.8385508 C120.424343,28.2513373 119.312703,30.0393739 116.520726,32.2026607 C115.816379,32.577371 115.241055,33.4624618 114.794753,34.8579329 C114.125301,36.9511396 114.898203,43.9288676 106.526487,50.7441612 L97.3145735,168.747943"
        />
        <path
          className="sb"
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M108.877129,17.2984293 C108.960388,18.7102787 108.048348,21.2301318 106.141008,24.8579887 C106.141008,24.8579887 106.141008,24.8579887 106.141008,24.8579887 L106.141008,24.8579887 C105.557654,25.9675584 104.185267,26.3941402 103.075698,25.8107858 C102.050619,25.2718522 101.595666,24.0476064 102.020022,22.9700359 C103.013166,20.448232 103.509722,18.8900764 103.509722,18.2955818"
        />
        <path
          className="sb"
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M114.847023,21.9007318 C114.930308,23.3108573 114.01896,25.8275756 112.112979,29.4508868 C112.112979,29.4508868 112.112979,29.4508868 112.112979,29.4508868 L112.112979,29.4508868 C111.513093,30.5912816 110.102317,31.0294511 108.961923,30.4295657 C108.024237,29.9363118 107.536637,28.8731613 107.774583,27.8407195 C108.405579,25.1029648 108.721047,23.4260568 108.721014,22.8100014"
          transform="rotate(13 111.284 26.3)"
        />
        <path
          className="sb"
          // stroke={baseColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.765"
          d="M99 22.946896C100.883344 22.6916104 102.059815 22.2209049 102.529412 21.5347794M107.823529 24.0059835C108.200198 23.9421621 108.435492 23.8244858 108.529412 23.6529544M112.764706 30.5018294C112.966062 32.0543653 113.81529 32.6027708 115.312389 32.1470459 116.809488 31.691321 117.96026 31.0369703 118.764706 30.183994"
        />
        <path
          fill={primaryColor}
          d="M103.754466 25.1402069L104.381165 25.3921517C104.822635 25.5696589 105.325339 25.3651341 105.51749 24.9298379 106.158609 23.4774583 106.230254 22.6414183 105.732425 22.4217178 104.862009 22.0375882 104.503328 22.3022489 103.936973 22.8679346 103.684227 23.1203817 103.45936 23.4973835 103.262373 23.99894L103.262321 23.9989195C103.085179 24.4499469 103.304881 24.9594367 103.754466 25.1402069zM109.048584 29.9061007L109.675283 30.1580455C110.116753 30.3355527 110.619457 30.1310279 110.811608 29.6957317 111.452727 28.2433521 111.524372 27.4073121 111.026543 27.1876116 110.156126 26.803482 109.797446 27.0681426 109.23109 27.6338284 108.978344 27.8862754 108.753478 28.2632773 108.55649 28.7648338L108.556438 28.7648133C108.379296 29.2158407 108.598998 29.7253305 109.048584 29.9061007z"
        />
        <ellipse
          cx="114.706"
          cy="30.714"
          fill={primaryColor}
          rx="1.059"
          ry="1.059"
        />
        <g transform="translate(2.118 .177)">
          <mask id="joels-hand-rotated-b" fill={colors.white}>
            <use xlinkHref="#joels-hand-rotated-a" />
          </mask>
          <ellipse
            cx="97.259"
            cy="122.148"
            className="fb"
            // fill={baseColor}
            mask="url(#joels-hand-rotated-b)"
            rx="1.059"
            ry="1.059"
          />
          <ellipse
            cx="97.259"
            cy="128.503"
            className="fb"
            // fill={baseColor}
            mask="url(#joels-hand-rotated-b)"
            rx="1.059"
            ry="1.059"
          />
          <ellipse
            cx="93.554"
            cy="124.972"
            fill={primaryColor}
            mask="url(#joels-hand-rotated-b)"
            rx="1.059"
            ry="1.059"
          />
          <path
            className="fb sb"
            // fill={baseColor}
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M103.584141,78.7721076 L92.529795,78.7719553 C91.2627933,78.7719388 90.2356989,77.7448177 90.2357155,76.477816 C90.2357242,75.8045558 90.5314758,75.1652842 91.0445956,74.7294088 C92.0406224,73.8833229 93.4181214,73.2932699 95.1770926,72.9592498 L95.1770714,71.3294349 C95.618537,67.381465 97.9643673,65.7301735 102.214562,66.3755605"
            mask="url(#joels-hand-rotated-b)"
            transform="rotate(3 96.91 72.506)"
          />
          <path
            className="fb sb"
            // fill={baseColor}
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M99.6943906,164.028652 L88.6400447,164.0285 C87.373043,164.028483 86.3459486,163.001362 86.3459652,161.734361 C86.3459739,161.0611 86.6417255,160.421829 87.1548454,159.985953 C88.1508721,159.139867 89.5283711,158.549814 91.2873423,158.215794 L91.2873211,156.585979 C91.7287867,152.638009 94.074617,150.986718 98.3248121,151.632105"
            mask="url(#joels-hand-rotated-b)"
            transform="rotate(3 93.02 157.762)"
          />
          <path
            className="fb"
            // fill={baseColor}
            d="M56.3400175,150.965513 L54.1392453,150.563518 C53.9462111,150.528258 53.8183026,150.343151 53.8535536,150.150068 C53.8801019,150.004654 53.9938672,149.89086 54.1392453,149.864305 L56.3400175,149.46231 C56.4853956,149.435755 56.5991609,149.321962 56.6257092,149.176547 L57.027604,146.975227 C57.062855,146.782144 57.2479167,146.654204 57.4409509,146.689464 C57.5863291,146.716018 57.7000943,146.829812 57.7266426,146.975227 L58.1285375,149.176547 C58.1550858,149.321962 58.268851,149.435755 58.4142292,149.46231 L60.6150013,149.864305 C60.8080355,149.899565 60.935944,150.084673 60.900693,150.277755 C60.8741447,150.42317 60.7603795,150.536963 60.6150013,150.563518 L58.4142292,150.965513 C58.268851,150.992068 58.1550858,151.105862 58.1285375,151.251276 L57.7266426,153.452597 C57.6913916,153.645679 57.5063299,153.77362 57.3132957,153.73836 C57.1679175,153.711805 57.0541523,153.598011 57.027604,153.452597 L56.6257092,151.251276 C56.5991609,151.105862 56.4853956,150.992068 56.3400175,150.965513 Z"
            mask="url(#joels-hand-rotated-b)"
          />
          <path
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M45.6270939 145.271503C47.6132716 133.816138 51.0305253 126.318788 55.8788549 122.779456 60.7271846 119.240123 66.4871755 118.170451 73.1588279 119.570441 80.4102966 121.709784 86.2390068 120.404729 90.6449584 115.655276 95.0509101 110.905823 98.2085128 105.597644 100.117767 99.7307405L109.111643 92.512346M32.8477116 125.47209C38.7643455 110.160348 48.5708422 102.504477 62.2672019 102.504477 75.9635615 102.504477 85.5696544 95.5136412 91.0854807 81.5319689 91.7560167 80.2285367 92.5307355 76.5783617 93.409637 70.5814442 94.7279894 61.5860678 97.2578715 57.1421486 103.276539 57.1421486"
            mask="url(#joels-hand-rotated-b)"
          />
          <path
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M39.1269676,135.210172 C43.0033228,124.435201 46.6895074,117.846329 50.1855215,115.443557 C55.4295427,111.839398 60.546517,111.839398 62.8776258,111.839398 C65.2087346,111.839398 79.6447033,112.041812 87.7745873,103.485143 C93.1945101,97.7806963 96.7361946,91.3963484 98.399641,84.3320992 C100.221605,73.5172458 101.782727,67.7670235 103.083006,67.0814324 C104.383285,66.3958412 109.3164,68.6695699 117.882353,73.9026183"
            mask="url(#joels-hand-rotated-b)"
          />
          <polyline
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            points="3.309 141.453 32.191 122.405 44.367 149.673"
            mask="url(#joels-hand-rotated-b)"
            transform="rotate(-8 23.838 136.04)"
          />
          <polygon
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            points="-12.818 167.729 13.844 138.179 23.803 131.714 24.931 140.82 18.485 147.823 20.822 152.924 9.122 161.401"
            mask="url(#joels-hand-rotated-b)"
            transform="rotate(-8 6.056 149.722)"
          />
          <polygon
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            points="24.956 138.512 32.282 132.544 34.04 144.118 30.992 148.388 35.998 151.817 24.955 164.959 9.147 159.092 20.848 150.616 18.511 145.515"
            mask="url(#joels-hand-rotated-b)"
            transform="rotate(-8 22.573 148.751)"
          />
          <path
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M41.1931992,136.637332 C41.1931992,136.637332 40.6695599,135.603675 39.6222812,133.53636 L34.1092022,142.023153 L31.0614469,146.293213 L36.0673481,149.721752 L25.0247303,162.863397 L40.6494226,161.504726 L50.1525883,158.337456"
            mask="url(#joels-hand-rotated-b)"
            transform="rotate(-8 37.589 148.2)"
          />
          <path
            className="sa"
            // stroke={altColor}
            strokeWidth=".588"
            mask="url(#joels-hand-rotated-b)"
          />
          <path
            fill={primaryColor}
            d="M7.02351336,161.472629 L13.9532048,151.455849 C14.2304513,151.055092 14.780081,150.954968 15.1808372,151.232214 C15.3714899,151.36411 15.502575,151.565739 15.5457524,151.793512 L16.7859515,158.335899 L22.0107469,153.584504 C22.3338955,153.290635 22.8234195,153.277421 23.1619513,153.553429 L26.859946,156.568437 L30.6035777,150.136129 C30.8487014,149.714957 31.3888405,149.572242 31.810012,149.817366 C31.9543105,149.901348 32.0718204,150.024547 32.1488918,150.172652 L35.4771519,156.568437 L37.2033795,154.287561 C37.4974604,153.89899 38.0508592,153.82239 38.4394303,154.116471 C38.5622045,154.20939 38.6585267,154.332818 38.7188257,154.474492 L40.3623105,158.335899 L30.2118378,169.630516 L8.63155411,170.180595 L7.02351336,161.472629 Z"
            mask="url(#joels-hand-rotated-b)"
          />
          <path
            className="sb"
            // stroke={baseColor}
            strokeDasharray="3.529 3.529"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M75.5535939 158.030969C82.2392908 155.135516 86.9306024 152.800111 89.6275285 151.024754 92.3244546 149.249396 95.4347714 146.449073 98.9584788 142.623785M46.0649513 146.68362L52.0708102 156.490236"
            mask="url(#joels-hand-rotated-b)"
          />
          <g transform="rotate(-38 169.513 12.182)">
            <g strokeLinejoin="round">
              <use
                className="fa sa"
                // fill={altColor}
                // stroke={altColor}
                strokeWidth="2.118"
                xlinkHref="#joels-hand-rotated-c"
              />
              <use
                className="sb"
                // stroke={baseColor}
                strokeWidth="1.059"
                xlinkHref="#joels-hand-rotated-c"
              />
            </g>
            <path
              className="sb"
              // stroke={baseColor}
              strokeLinecap="round"
              strokeWidth="1.059"
              d="M20.2585758,6.08293678 C19.6139199,5.04973786 18.6564984,4.13874329 17.4726224,3.41182496 C15.6214972,2.27520508 13.2167159,1.58863126 10.5882353,1.58863126 C7.75501249,1.58863126 5.18169598,2.38633041 3.28150878,3.68551171 C2.40810463,4.28266884 1.67691247,4.98577408 1.12805971,5.76606229"
            />
            <path
              className="fb"
              // fill={baseColor}
              d="M10.5882353,11.5065445 C10.7519548,11.131451 11.0372609,10.9439043 11.4441536,10.9439043 C11.8510463,10.9439043 12.1363524,11.131451 12.300072,11.5065445 C12.4302116,11.9233151 12.3200934,12.2931989 11.9697175,12.6161961 C11.6193416,12.9391933 11.1588475,13.382012 10.5882353,13.9446522 C10.0176231,13.382012 9.557129,12.9391933 9.20675308,12.6161961 C8.85637715,12.2931989 8.74625901,11.9233151 8.87639864,11.5065445 C9.04011818,11.131451 9.32542429,10.9439043 9.73231697,10.9439043 C10.1392096,10.9439043 10.4245158,11.131451 10.5882353,11.5065445 Z"
            />
            <ellipse
              cx="6.882"
              cy="9.002"
              className="fb"
              // fill={baseColor}
              rx="1"
              ry="1"
            />
            <ellipse
              cx="14.471"
              cy="9.002"
              className="fb"
              // fill={baseColor}
              rx="1"
              ry="1"
            />
            <path
              className="fb"
              // fill={baseColor}
              d="M6.88235294,12.7090501 C6.68742891,12.7090501 6.52941176,12.5509936 6.52941176,12.3560209 C6.52941176,12.1610483 6.68742891,12.0029918 6.88235294,12.0029918 C7.07727697,12.0029918 7.23529412,12.1610483 7.23529412,12.3560209 C7.23529412,12.5509936 7.07727697,12.7090501 6.88235294,12.7090501 Z M7.58823529,13.9446522 C7.39331126,13.9446522 7.23529412,13.7865957 7.23529412,13.591623 C7.23529412,13.3966504 7.39331126,13.2385939 7.58823529,13.2385939 C7.78315932,13.2385939 7.94117647,13.3966504 7.94117647,13.591623 C7.94117647,13.7865957 7.78315932,13.9446522 7.58823529,13.9446522 Z M5.82352941,13.591623 C5.62860538,13.591623 5.47058824,13.4335665 5.47058824,13.2385939 C5.47058824,13.0436212 5.62860538,12.8855647 5.82352941,12.8855647 C6.01845344,12.8855647 6.17647059,13.0436212 6.17647059,13.2385939 C6.17647059,13.4335665 6.01845344,13.591623 5.82352941,13.591623 Z M14.1176471,12.7090501 C13.922723,12.7090501 13.7647059,12.5509936 13.7647059,12.3560209 C13.7647059,12.1610483 13.922723,12.0029918 14.1176471,12.0029918 C14.3125711,12.0029918 14.4705882,12.1610483 14.4705882,12.3560209 C14.4705882,12.5509936 14.3125711,12.7090501 14.1176471,12.7090501 Z M13.4117647,13.9446522 C13.2168407,13.9446522 13.0588235,13.7865957 13.0588235,13.591623 C13.0588235,13.3966504 13.2168407,13.2385939 13.4117647,13.2385939 C13.6066887,13.2385939 13.7647059,13.3966504 13.7647059,13.591623 C13.7647059,13.7865957 13.6066887,13.9446522 13.4117647,13.9446522 Z M15.1764706,13.591623 C14.9815466,13.591623 14.8235294,13.4335665 14.8235294,13.2385939 C14.8235294,13.0436212 14.9815466,12.8855647 15.1764706,12.8855647 C15.3713946,12.8855647 15.5294118,13.0436212 15.5294118,13.2385939 C15.5294118,13.4335665 15.3713946,13.591623 15.1764706,13.591623 Z"
            />
            <path
              className="sb"
              // stroke={baseColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.059"
              d="M10.5882353,13.9446522 C10.5882353,14.6507105 10.1764706,15.0037397 9.35294118,15.0037397 L9.08823529,15.0037397"
            />
            <path
              className="sb"
              // stroke={baseColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.059"
              d="M12.0882353,13.9446522 C12.0882353,14.6507105 11.6764706,15.0037397 10.8529412,15.0037397 L10.5882353,15.0037397"
              transform="matrix(-1 0 0 1 22.676 0)"
            />
            <path
              className="sb"
              fill="#000"
              // stroke={baseColor}
              strokeWidth=".882"
              d="M1.85294118,4.76589379 L1.85304686,3.91279743 C1.85304686,3.71793177 2.01101669,3.55996194 2.20588235,3.55996194 C2.24213406,3.55996194 2.27816926,3.56554871 2.31271915,3.57652555 C2.68452352,3.69465136 2.91361713,3.79691646 3,3.88332087 L2.73529412,4.05983545 L1.85294118,4.76589379 Z"
            />
            <path
              className="sb"
              fill="#000"
              // stroke={baseColor}
              strokeWidth=".882"
              d="M18.0882353,4.76589379 L18.088341,3.91279743 C18.088341,3.71793177 18.2463108,3.55996194 18.4411765,3.55996194 C18.4774282,3.55996194 18.5134634,3.56554871 18.5480133,3.57652555 C18.9198176,3.69465136 19.1489112,3.79691646 19.2352941,3.88332087 L18.9705882,4.05983545 L18.0882353,4.76589379 Z"
              transform="matrix(-1 0 0 1 37.324 0)"
            />
          </g>
          <path
            className="sb"
            // stroke={baseColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.059"
            d="M30.2118378,121.375225 L23.5080543,138.280196"
          />
          <g transform="translate(60.73 114.911)">
            <path
              className="fb sb"
              // fill={baseColor}
              // stroke={baseColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".588"
              d="M1.33348887e-12,5.29543755 C1.66122655,2.19472357 5.77567535,0 10.5882353,0 C15.4007952,0 19.515244,2.19472357 21.1764706,5.29543755 C19.515244,8.39615152 15.4007952,10.5908751 10.5882353,10.5908751 C5.77567535,10.5908751 1.66122655,8.39615152 -1.23234756e-14,5.29543755 Z"
            />
            <ellipse
              cx="10.588"
              cy="5.322"
              className="fa"
              // fill={altColor}
              rx="4.412"
              ry="4.413"
            />
            <ellipse
              cx="10.588"
              cy="5.322"
              className="fb sb"
              // fill={baseColor}
              // stroke={baseColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".588"
              rx="1.941"
              ry="1.942"
            />
          </g>
          <g strokeLinecap="round" transform="rotate(-16 511.603 -136.898)">
            <g
              className="sa"
              // stroke={altColor}
              strokeWidth="1.059"
              transform="rotate(30 5.795 22.948)"
            >
              <ellipse
                cx="7.5"
                cy="7.491"
                className="fb"
                // fill={baseColor}
                rx="8.029"
                ry="8.021"
              />
              <path d="M7.5,2.62188737 C5.25840904,2.62188737 3.37017779,4.13300622 2.8007108,6.19098413 M2.625,7.49110677 C2.625,8.14596745 2.75442839,8.77063435 2.98912873,9.34097969" />
            </g>
            <g strokeLinejoin="round">
              <use
                className="sa"
                // stroke={altColor}
                strokeWidth="2.118"
                xlinkHref="#joels-hand-rotated-d"
              />
              <use
                stroke={primaryColor}
                strokeWidth="1.059"
                xlinkHref="#joels-hand-rotated-d"
              />
            </g>
          </g>
          <path
            className="fb"
            // fill={baseColor}
            d="M57.5134104 134.320754L54.4323294 133.757961C54.1620816 133.708597 53.9830096 133.449446 54.032361 133.179131 54.0695286 132.97555 54.2288 132.816239 54.4323294 132.779063L57.5134104 132.21627C57.7169399 132.179093 57.8762112 132.019782 57.9133788 131.816201L58.4760316 128.734352C58.525383 128.464037 58.7844694 128.28492 59.0547173 128.334284 59.2582467 128.371461 59.417518 128.530772 59.4546856 128.734352L60.0173384 131.816201C60.054506 132.019782 60.2137774 132.179093 60.4173068 132.21627L63.4983878 132.779063C63.7686357 132.828426 63.9477076 133.087577 63.8983562 133.357893 63.8611886 133.561473 63.7019172 133.720784 63.4983878 133.757961L60.4173068 134.320754C60.2137774 134.357931 60.054506 134.517242 60.0173384 134.720822L59.4546856 137.802671C59.4053342 138.072986 59.1462478 138.252103 58.876 138.202739 58.6724705 138.165562 58.5131992 138.006251 58.4760316 137.802671L57.9133788 134.720822C57.8762112 134.517242 57.7169399 134.357931 57.5134104 134.320754zM82.2192928 130.613947L79.1382118 130.051154C78.8679639 130.001791 78.688892 129.74264 78.7382434 129.472324 78.775411 129.268744 78.9346823 129.109433 79.1382118 129.072256L82.2192928 128.509463C82.4228222 128.472286 82.5820935 128.312975 82.6192612 128.109395L83.1819139 125.027546C83.2312654 124.757231 83.4903518 124.578114 83.7605996 124.627478 83.964129 124.664655 84.1234004 124.823966 84.160568 125.027546L84.7232208 128.109395C84.7603884 128.312975 84.9196597 128.472286 85.1231892 128.509463L88.2042702 129.072256C88.474518 129.12162 88.65359 129.380771 88.6042385 129.651086 88.5670709 129.854666 88.4077996 130.013977 88.2042702 130.051154L85.1231892 130.613947C84.9196597 130.651124 84.7603884 130.810435 84.7232208 131.014015L84.160568 134.095865C84.1112166 134.36618 83.8521302 134.545296 83.5818823 134.495933 83.3783529 134.458756 83.2190815 134.299445 83.1819139 134.095865L82.6192612 131.014015C82.5820935 130.810435 82.4228222 130.651124 82.2192928 130.613947z"
          />
          <ellipse
            cx="64.965"
            cy="128.503"
            className="fb"
            // fill={baseColor}
            rx="1.059"
            ry="1.059"
          />
          <ellipse
            cx="98.318"
            cy="115.97"
            className="fb"
            // fill={baseColor}
            rx="1.059"
            ry="1.059"
          />
          <ellipse
            cx="93.907"
            cy="118.794"
            fill={primaryColor}
            rx="1.059"
            ry="1.059"
          />
          <ellipse
            cx="90.73"
            cy="121.266"
            fill={primaryColor}
            rx="1.059"
            ry="1.059"
          />
          <ellipse
            cx="54.024"
            cy="138.211"
            className="fb"
            // fill={baseColor}
            rx="1"
            ry="1"
            transform="matrix(-1 0 0 1 108.048 0)"
          />
          <ellipse
            cx="52.436"
            cy="144.389"
            className="fb"
            // fill={baseColor}
            rx="1.588"
            ry="1.589"
            transform="matrix(-1 0 0 1 104.872 0)"
          />
          <g transform="translate(54.024 89.493)">
            <mask id="joels-hand-rotated-f" fill={colors.white}>
              <use xlinkHref="#joels-hand-rotated-e" />
            </mask>
            <path
              className="fb"
              // fill={baseColor}
              d="M1.55607012,12.3968917 C1.5409071,12.2499246 1.53313767,12.10078 1.53313767,11.9498314 C1.53313767,9.55822796 3.48347526,7.61945027 5.88933859,7.61945027 C6.69689813,7.61945027 7.45313372,7.8378918 8.10151296,8.21857755 C8.76370831,5.25643715 11.4225329,3.04161875 14.6017404,3.04161875 C17.8374386,3.04161875 20.5340964,5.33584573 21.1353677,8.37717814 C21.4727883,8.28647059 21.8276971,8.23807615 22.1939763,8.23807615 C24.4279923,8.23807615 26.23902,10.0383697 26.23902,12.2591444 C26.23902,12.3052455 26.2382396,12.3511654 26.2366911,12.3968917 L1.55607012,12.3968917 Z"
              mask="url(#joels-hand-rotated-f)"
              transform="rotate(-7 13.886 7.72)"
            />
          </g>
          <g
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="rotate(-101 85.99 22.853)"
          >
            <use
              className="fb sb"
              // fill={baseColor}
              // stroke={baseColor}
              strokeWidth="2.118"
              xlinkHref="#joels-hand-rotated-g"
            />
            <use
              className="sb"
              // stroke={baseColor}
              strokeWidth="1.059"
              xlinkHref="#joels-hand-rotated-g"
            />
            <ellipse
              cx="12.353"
              cy="6.209"
              className="fa sb"
              // fill={altColor}
              // stroke={baseColor}
              strokeWidth="1.059"
              rx="6.176"
              ry="6.147"
            />
            <ellipse
              cx="12.353"
              cy="6.209"
              fill={primaryColor}
              stroke={primaryColor}
              strokeWidth=".618"
              rx="2.779"
              ry="2.766"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Hand
